var render = function render(){var _vm=this,_c=_vm._self._c;return (['tradingviewonline', 'stage'].includes(_vm.brand))?_c('TradingViewLoginModal'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }